import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className="mt-10 p-6 text-center text-[#5A4B41] dark:text-[#EDE4DC] bg-[#d3c1b0] dark:bg-[#26211f] rounded-t-xl">
      할일 앱 서비스 개발 @ 문유비
    </footer>
  );
};

export default Footer;
